if (!customElements.get("multiship-button")) {
  class MultishipButton extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      const input = this.querySelector("input");
      if (input) input.checked = !input.checked;

      window.location.href = this.getAttribute("data-url") ?? "/a/gs/cart/";
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
    }
  }

  customElements.define("multiship-button", MultishipButton);
}
